// W-0821 — Modal pós-lançamento: transferidos / ignorados (com motivo) / falhas externas.
// ADR-002: falhas externas (SCPC/Monitora) NÃO derrubam transação — vêm separadas para retry.

import React from 'react';
import { Modal, Button, Tab, Tabs, Table, Badge, Alert } from 'react-bootstrap';

const ModalSumarioLancamento = ({
  show,
  transferidos,
  ignorados,
  falhasExternas,
  onFechar,
}) => {
  const totalT = transferidos.length;
  const totalI = ignorados.length;
  const totalF = falhasExternas.length;
  return (
    <Modal show={show} onHide={onFechar} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Sumário do lançamento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <Badge bg="success" className="me-2">
            {totalT} transferido(s)
          </Badge>
          <Badge bg="warning" text="dark" className="me-2">
            {totalI} ignorado(s)
          </Badge>
          <Badge bg="danger">{totalF} falha(s) em integração externa</Badge>
        </div>
        <Tabs defaultActiveKey="transferidos" className="mb-2">
          <Tab eventKey="transferidos" title={`Transferidos (${totalT})`}>
            {totalT === 0 ? (
              <Alert variant="info" className="my-2 py-2">
                Nenhum boleto transferido.
              </Alert>
            ) : (
              <div className="table-responsive" style={{ maxHeight: 320 }}>
                <Table size="sm" striped bordered>
                  <thead>
                    <tr>
                      <th>Boleto</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transferidos.map((b) => (
                      <tr key={`t-${b}`}>
                        <td>{b}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </Tab>
          <Tab eventKey="ignorados" title={`Ignorados (${totalI})`}>
            {totalI === 0 ? (
              <Alert variant="info" className="my-2 py-2">
                Nenhum boleto ignorado.
              </Alert>
            ) : (
              <div className="table-responsive" style={{ maxHeight: 320 }}>
                <Table size="sm" striped bordered>
                  <thead>
                    <tr>
                      <th>Boleto</th>
                      <th>Motivo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ignorados.map((item, idx) => (
                      <tr key={`i-${item.codigo_boleto}-${idx}`}>
                        <td>{item.codigo_boleto}</td>
                        <td>{item.motivo}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </Tab>
          <Tab eventKey="falhas" title={`Falhas externas (${totalF})`}>
            {totalF === 0 ? (
              <Alert variant="success" className="my-2 py-2">
                Sem falhas em integração externa.
              </Alert>
            ) : (
              <>
                <Alert variant="warning" className="py-2 mb-2">
                  Os boletos abaixo foram transferidos, mas a notificação
                  externa (SCPC/Monitora) falhou. Retry administrativo
                  disponível.
                </Alert>
                <div className="table-responsive" style={{ maxHeight: 320 }}>
                  <Table size="sm" striped bordered>
                    <thead>
                      <tr>
                        <th>Boleto</th>
                        <th>Integração</th>
                        <th>Erro</th>
                      </tr>
                    </thead>
                    <tbody>
                      {falhasExternas.map((f, idx) => (
                        <tr key={`f-${f.codigo_boleto}-${f.integracao}-${idx}`}>
                          <td>{f.codigo_boleto}</td>
                          <td>{f.integracao}</td>
                          <td>{f.mensagem || f.erro}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </>
            )}
          </Tab>
        </Tabs>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onFechar}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalSumarioLancamento;
